import { useState, useRef, useEffect, useMemo } from "react";
import { classNames } from "primereact/utils";
import { useHistory, useLocation, Route } from "react-router-dom";
import AppTopbar from "../../AppTopbar";
import AppMenu from "../../AppMenu";
import AppInlineProfile from "../../AppInlineProfile";
import { Tooltip } from "primereact/tooltip";
import logoWhiteHorizontal from "../images/logo-white-horizontal.png";
import "../../pages/UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import localeText from "../../locale";
import { Dialog } from "primereact/dialog";
import ConfirmDocument from "../../components/ConfirmDocument/ConfirmDocument";
import ListUsers from "./components/ListUsers/ListUsers";
import AdminBackofficeHome from "./components/AdminBackofficeHome/AdminBackofficeHome";
import ListProducts from "./components/ListProducts/ListProducts";
import ListWithdrawRequests from "./components/ListWithdrawRequests/ListWithdrawRequests";
import ListCategoriesRegistered from "./components/ListCategoriesRegistered/ListCategoriesRegistered";
import NewCategories from "./components/NewCategories/NewCategories";
import Orders from "../UserDashboard/components/Orders/Orders";
import ListBrands from "./components/ListBrands/ListBrands";
import NewBrands from "./components/NewBrands/NewBrands";
import ListType from "./components/ListType/ListType";
import NewType from "./components/NewType/NewType";
import ListSubcategories from "./components/ListSubcategories/ListSubcategories";
import NewSubcategory from "./components/NewSubcategory/NewSubcategory";
import ListUserAddress from "./components/UserAdress/ListUserAddress";
import PaidSubscriptions from "./components/PaidSubscriptions/PaidSubscriptions";
import OrderDetails from "../UserDashboard/components/OrderDetails/OrderDetails";
import { useToastContext } from "../../contexts/ToastContext/ToastContext";
import useGetUserInfo from "../../hooks/useGetUserInfo";
import ListBangood from "./components/bangoodList";
import MetaAdsConfig from "./components/IntegrationsConfig/MetaAdsConfig";
import GtmConfig from "./components/IntegrationsConfig/GtmConfig";
import BankTransfers from "./components/bankTransfers";
import PendingOrders from "./components/PendingOrders/PendingOrders";
import { Redirect, Switch } from "react-router-dom";
import Banners from "./components/Banners/Banners";

const AdminBackoffice = () => {
  const { showErrorToast: newShowErrorToast } = useToastContext();
  const { userInfo } = useGetUserInfo({
    onUserInfoError: (messageCode) => newShowErrorToast({ code: messageCode }),
  });
  const [menuActive, setMenuActive] = useState(false);
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [topbarMenuActive, setTopbarMenuActive] = useState(false);
  const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
  const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
  const [activeTopbarItem, setActiveTopbarItem] = useState(null);
  const [inlineMenuActive, setInlineMenuActive] = useState(false);
  const [configActive, setConfigActive] = useState(false);
  const copyTooltipRef = useRef();
  const location = useLocation();
  const [displayCouponDialog, setDisplayCouponDialog] = useState(false);

  const menuMode = "static";
  const darkMenu = true;
  const profileMode = "popup";
  const inputStyle = "outlined";
  const ripple = false;

  const history = useHistory();

  let menuClick = false;
  let configClick = false;
  let topbarItemClick = false;
  let inlineMenuClick = false;

  const menu = [
    {
      label: localeText("dashboard"),
      icon: "pi pi-fw pi-chart-line",
      items: [
        { label: localeText("adminDashboard"), icon: "pi pi-fw pi-chart-line", to: "/dashboard" },
      ],
    },
    {
      label: localeText("users"),
      icon: "pi pi-fw pi-users",
      items: [
        {
          label: localeText("bankTransfers"),
          icon: "pi pi-money-bill",
          to: "/dashboard-banktransfers",
        },
        {
          label: "Managers",
          icon: "pi pi-fw pi-user",
          items: [
            {
              label: localeText("list"),
              icon: "pi pi-fw pi-list",
              to: "/dashboard-listareamanagers",
            },
          ],
        },
        {
          label: "Partners",
          icon: "pi pi-fw pi-user",
          items: [
            {
              label: localeText("list"),
              icon: "pi pi-fw pi-list",
              to: "/dashboard-listbusinesspartners",
            },
          ],
        },
        {
          label: "Customers",
          icon: "pi pi-fw pi-user",
          items: [
            {
              label: localeText("list"),
              icon: "pi pi-fw pi-list",
              to: "/dashboard-listspecialcustomers",
            },
          ],
        },
        {
          label: "Promoters",
          icon: "pi pi-fw pi-user",
          items: [
            {
              label: localeText("list"),
              icon: "pi pi-fw pi-list",
              to: "/dashboard-listsalepromoters",
            },
          ],
        },
        {
          label: "Sellers",
          icon: "pi pi-fw pi-user",
          items: [
            { label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-listsellers" },
          ],
        },
      ],
    },
    {
      label: localeText("store"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        {
          label: localeText("principalBanner"),
          icon: "pi pi-fw pi-images",
          to: "/dashboard-banners",
        },
        { label: "Sub Banner 1", icon: "pi pi-fw pi-images", to: "/dashboard-subbanners1" },
        { label: "Sub Banner 2", icon: "pi pi-fw pi-images", to: "/dashboard-subbanners2" },
        { label: "Sub Banner 3", icon: "pi pi-fw pi-images", to: "/dashboard-subbanners3" },
      ],
    },
    {
      label: localeText("adverts"),
      icon: "pi pi-fw pi-box",
      items: [
        { label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-listproducts" },
      ],
    },
    {
      label: localeText("orders"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        { label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-listorders" },
        { label: localeText("pendingIssues"), icon: "pi pi-fw pi-list", to: "/dashboard-pendings" },
      ],
    },
    {
      label: localeText("withdrawRequests"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        {
          label: localeText("list"),
          icon: "pi pi-fw pi-list",
          to: "/dashboard-listwithdrawrequests",
        },
      ],
    },
    {
      label: localeText("category"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        { label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-listcategory" },
        {
          label: localeText("newCategory"),
          icon: "pi pi-fw pi-plus",
          to: "/dashboard-newcategories",
        },
      ],
    },
    {
      label: localeText("subcategory"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        { label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-listsubcategories" },
        {
          label: localeText("newsubcategory"),
          icon: "pi pi-fw pi-plus",
          to: "/dashboard-newsubcategory",
        },
      ],
    },
    {
      label: localeText("brands"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        { label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-listbrands" },
        { label: localeText("newBrand"), icon: "pi pi-fw pi-plus", to: "/dashboard-newbrands" },
      ],
    },
    {
      label: localeText("types"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        { label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-listtypes" },
        { label: localeText("newType"), icon: "pi pi-fw pi-plus", to: "/dashboard-newtypes" },
      ],
    },
    {
      label: localeText("address"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [{ label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-address" }],
    },
    {
      label: localeText("paidSubscriptions"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        { label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-paidsubscriptions" },
      ],
    },
    {
      label: "Bangood",
      icon: "pi pi-fw pi-shopping-cart",
      items: [{ label: localeText("list"), icon: "pi pi-fw pi-list", to: "/dashboard-bangood" }],
    },
    {
      label: localeText("integrations"),
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        { label: "Meta Ads", icon: "pi pi-fw pi-cog", to: "/dashboard-metaads" },
        { label: "Google Tag Manager", icon: "pi pi-fw pi-cog", to: "/dashboard-gtm" },
      ],
    },
  ];

  useEffect(() => {
    copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
  }, [location]);

  const onDocumentClick = () => {
    if (!topbarItemClick) {
      setActiveTopbarItem(null);
      setTopbarMenuActive(false);
    }

    if (!menuClick) {
      if (isHorizontal() || isSlim()) {
        setMenuActive(false);
      }
      hideOverlayMenu();
    }

    if (!inlineMenuClick && profileMode === "inline" && isSlim() && !isMobile()) {
      setInlineMenuActive(false);
    }

    if (configActive && !configClick) {
      setConfigActive(false);
    }

    inlineMenuClick = false;
    configClick = false;
    topbarItemClick = false;
    menuClick = false;
  };

  const onMenuitemClick = (event) => {
    if (!event.item.items) {
      hideOverlayMenu();

      if (isSlim() || isHorizontal()) {
        setMenuActive(false);
      }
    }
  };

  const onRootMenuitemClick = () => {
    setMenuActive((prevMenuActive) => !prevMenuActive);
  };

  const onMenuClick = () => {
    menuClick = true;

    if (inlineMenuActive && !inlineMenuClick) {
      setInlineMenuActive(false);
    }
  };

  const isMenuVisible = () => {
    if (isDesktop()) {
      if (menuMode === "static") return !staticMenuDesktopInactive;
      else if (menuMode === "overlay") return overlayMenuActive;
      else return true;
    } else {
      return true;
    }
  };

  const onMenuButtonClick = (event) => {
    menuClick = true;
    setTopbarMenuActive(false);

    if (isOverlay() && !isMobile()) {
      setOverlayMenuActive((prevOverlayMenuActive) => !prevOverlayMenuActive);
    } else {
      if (isDesktop()) {
        setStaticMenuDesktopInactive(
          (prevStaticMenuDesktopInactive) => !prevStaticMenuDesktopInactive
        );
      } else {
        setStaticMenuMobileActive((prevStaticMenuMobileActive) => !prevStaticMenuMobileActive);
      }
    }

    event.preventDefault();
  };

  const onProfileButtonClick = (event) => {
    setInlineMenuActive((prevInlineMenuActive) => !prevInlineMenuActive);
    inlineMenuClick = true;

    if (isSlim() || isHorizontal()) {
      setMenuActive(false);
    }
  };

  const onTopbarMenuButtonClick = (event) => {
    topbarItemClick = true;
    setTopbarMenuActive((prevTopbarMenuActive) => !prevTopbarMenuActive);

    hideOverlayMenu();

    event.preventDefault();
  };

  const onTopbarItemClick = (event, item) => {
    topbarItemClick = true;

    if (activeTopbarItem === item) {
      setActiveTopbarItem(null);
    } else {
      setActiveTopbarItem(item);
    }

    event.preventDefault();
  };

  const hideOverlayMenu = () => {
    setOverlayMenuActive(false);
    setStaticMenuMobileActive(false);
  };

  const isDesktop = () => {
    return window.innerWidth > 896;
  };

  const isMobile = () => {
    return window.innerWidth <= 896;
  };

  const isOverlay = () => {
    return menuMode === "overlay";
  };

  const isHorizontal = () => {
    return menuMode === "horizontal";
  };

  const isSlim = () => {
    return menuMode === "slim";
  };

  const isStatic = () => {
    return menuMode === "static";
  };

  const hasInlineProfile = profileMode === "inline" && !isHorizontal();

  const containerClassName = classNames("layout-wrapper", {
    "layout-static": isStatic(),
    "layout-overlay": isOverlay(),
    "layout-overlay-active": overlayMenuActive,
    "layout-horizontal": isHorizontal(),
    "layout-slim": isSlim(),
    "layout-static-inactive": staticMenuDesktopInactive,
    "layout-mobile-active": staticMenuMobileActive,
    "layout-menu-dark": darkMenu,
    "layout-menu-light": !darkMenu,
    "p-input-filled": inputStyle === "filled",
    "p-ripple-disabled": !ripple,
  });

  const menuContainerClassName = classNames("layout-menu-container", {
    "layout-menu-container-inactive": !isMenuVisible(),
  });

  const routers = useMemo(
    () => ({
      path: "/dashboard",
      children: (
        <Switch>
          <Route exact path="/dashboard" component={AdminBackofficeHome} />
          <Route
            path="/dashboard-listareamanagers"
            component={() => <ListUsers plan="areamanager" />}
          />
          <Route
            path="/dashboard-listbusinesspartners"
            component={() => <ListUsers plan="businesspartner" />}
          />
          <Route
            path="/dashboard-listspecialcustomers"
            component={() => <ListUsers plan="specialcustomer" />}
          />
          <Route
            path="/dashboard-listsalepromoters"
            component={() => <ListUsers plan="salepromoter" />}
          />
          <Route path="/dashboard-listsellers" component={() => <ListUsers plan="sellers" />} />
          <Route path="/dashboard-listproducts" component={ListProducts} />
          <Route path="/dashboard-banktransfers" component={BankTransfers} />
          <Route path="/dashboard-listwithdrawrequests" component={ListWithdrawRequests} />
          <Route path="/dashboard-listcategory" component={ListCategoriesRegistered} />
          <Route path="/dashboard-newcategories" component={NewCategories} />
          <Route path="/dashboard-listbrands" component={ListBrands} />
          <Route path="/dashboard-newbrands" component={NewBrands} />
          <Route path="/dashboard-listtypes" component={ListType} />
          <Route path="/dashboard-newtypes" component={NewType} />
          <Route path="/dashboard-listsubcategories" component={ListSubcategories} />
          <Route path="/dashboard-newsubcategory" component={NewSubcategory} />
          <Route path="/dashboard-address" component={ListUserAddress} />
          <Route path="/dashboard-paidsubscriptions" component={PaidSubscriptions} />
          <Route path="/dashboard-listorders" component={() => <Orders admin={true} />} />
          <Route
            path="/dashboard-pendings"
            component={() => <PendingOrders admin={true} userInfo={userInfo?.user} />}
          />
          <Route
            path="/dashboard-purchasesdetails/"
            component={() => (
              <OrderDetails
                admin={true}
                sales={true}
                userInfo={userInfo?.user}
                plan={userInfo?.plan}
              />
            )}
          />
          <Route
            path="/dashboard-bangood"
            component={() => (
              <ListBangood admin={true} userInfo={userInfo?.user} plan={userInfo?.plan} />
            )}
          />
          <Route
            path="/dashboard-metaads"
            component={() => (
              <MetaAdsConfig admin={true} userInfo={userInfo?.user} plan={userInfo?.plan} />
            )}
          />
          <Route path="/dashboard-gtm" component={GtmConfig} />
          <Route
            path="/dashboard-banners"
            component={() => <Banners title={localeText("principalBanner")} type="main" />}
          />
          <Route
            path="/dashboard-subbanners1"
            component={() => <Banners title="Sub Banner 1" type="sub1" />}
          />
          <Route
            path="/dashboard-subbanners2"
            component={() => <Banners title="Sub Banner 2" type="sub2" />}
          />
          <Route
            path="/dashboard-subbanners3"
            component={() => <Banners title="Sub Banner 3" type="sub3" />}
          />
        </Switch>
      ),
    }),
    [userInfo]
  );

  return (
    <div className={containerClassName} onClick={onDocumentClick}>
      <ConfirmDocument />

      <Dialog
        header="Header"
        visible={displayCouponDialog}
        style={{ width: "50vw" }}
        onHide={() => setDisplayCouponDialog(false)}
      >
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
          sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
          est laborum.
        </p>
      </Dialog>

      <Tooltip
        ref={copyTooltipRef}
        target=".block-action-copy"
        position="bottom"
        content="Copied to clipboard"
        event="focus"
      />

      <AppTopbar
        topbarMenuActive={topbarMenuActive}
        activeTopbarItem={activeTopbarItem}
        onMenuButtonClick={onMenuButtonClick}
        onTopbarMenuButtonClick={onTopbarMenuButtonClick}
        onTopbarItemClick={onTopbarItemClick}
        isHorizontal={isHorizontal()}
        profileMode={profileMode}
        isMobile={isMobile}
        adminBackoffice={true}
      />

      <div className={menuContainerClassName} onClick={onMenuClick}>
        <div className="layout-menu-logo">
          <button className="p-link" onClick={() => history.push("/")}>
            <img
              id="layout-menu-logo"
              src={logoWhiteHorizontal}
              library="babylon-layout"
              alt="babylon-logo"
            />
          </button>
        </div>
        <div className="layout-menu-wrapper">
          <div className="menu-scroll-content">
            {hasInlineProfile && (
              <AppInlineProfile
                inlineMenuActive={inlineMenuActive}
                onProfileButtonClick={onProfileButtonClick}
              />
            )}
            <AppMenu
              model={menu}
              menuMode={menuMode}
              active={menuActive}
              onMenuitemClick={onMenuitemClick}
              onRootMenuitemClick={onRootMenuitemClick}
            />
          </div>
        </div>
      </div>

      <div className="layout-main">
        <div className="layout-content">
          <Switch>{routers.children}</Switch>
        </div>
      </div>

      {staticMenuMobileActive && <div className="layout-mask"></div>}
    </div>
  );
};

export default AdminBackoffice;
